import React from "react";

// MUI
import { Avatar, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "fit-content"
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1)
  }
}));

const Company = () => {
  const classes = useStyles();

  const user = {
    name: "Grace Hopper",
    avatar:
      "https://www.womenshistory.org/sites/default/files/styles/main_image/public/images/2018-07/Hopper-3%20square.jpg?itok=YOyaM_zT",
    bio: "Rear Admiral"
  };

  return (
    <div className={classes.root}>
      <Avatar
        alt="Company Logo"
        className={classes.avatar}
        src={user.avatar}
        component={"a"}
        href={"https://www.tapacenter.com"}
      />
      <Typography className={classes.name} variant="h4" align="center">
        {user.name}
      </Typography>
      <Typography variant="body2">{user.bio}</Typography>
    </div>
  );
};

export default Company;
